import BaseModelAPI from '../BaseModelAPI';

export default class Branch extends BaseModelAPI {
	static entity = 'branch';
	static entityName = 'branch';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.createdBy = '';
			this.updatedBy = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}